import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../../PrivateRoute';
import OnlineVisaLandingPage from '../pages/OnlineVisaLandingPage/OnlineVisaLandingPage';
import OnlineVisaOptionsPage from '../pages/OnlineVisaOptionsPage/OnlineVisaOptionsPage';
import OnlineVisaBookingPage from '../pages/OnlineVisaBookingPage/OnlineVisaBookingPage';
import OnlineVisaVoucherPage from '../pages/OnlineVisaVoucherPage/OnlineVisaVoucherPage';
import OnlineVisaInvoicePage from '../pages/OnlineVisaInvoicePage/OnlineVisaInvoicePage';
import { ONLINE_VISA_ROUTES } from '../constants/onlineVisaConstants';

/**
 * Self-contained route fragment for the online-visa module.
 *
 * Usage from /src/AppRoutes.jsx:
 *
 *   import OnlineVisaRoutes from './features/online-visa/routes/OnlineVisaRoutes';
 *   ...
 *   <Routes>
 *     ...existing routes
 *     {OnlineVisaRoutes()}
 *   </Routes>
 *
 * Returning raw <Route> elements (as a fragment) is the pattern that works
 * with React Router v6's <Routes> matcher — it won't accept a wrapping
 * component.
 */
function OnlineVisaRoutes() {
  return (
    <>
      <Route
        path={ONLINE_VISA_ROUTES.LANDING}
        element={
          <PrivateRoute>
            <OnlineVisaLandingPage />
          </PrivateRoute>
        }
      />
      <Route
        path={ONLINE_VISA_ROUTES.OPTIONS}
        element={
          <PrivateRoute>
            <OnlineVisaOptionsPage />
          </PrivateRoute>
        }
      />
      <Route
        path={ONLINE_VISA_ROUTES.BOOKING}
        element={
          <PrivateRoute>
            <OnlineVisaBookingPage />
          </PrivateRoute>
        }
      />
      <Route
        path={ONLINE_VISA_ROUTES.BOOKING_DETAILS}
        element={
          <PrivateRoute>
            <OnlineVisaVoucherPage />
          </PrivateRoute>
        }
      />
      <Route
        path={ONLINE_VISA_ROUTES.INVOICE}
        element={
          <PrivateRoute>
            <OnlineVisaInvoicePage />
          </PrivateRoute>
        }
      />
    </>
  );
}

export default OnlineVisaRoutes;
